
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91contestant_93jLnCpFi2zHZGiElxxfbDqJEpJC3x2u8ZY6olxRgrv7QMeta } from "/opt/buildhome/repo/app/pages/champ/[contestant].vue?macro=true";
import { default as _91show_93OJzgf_HFFv4744gROOKEgqWkeEIwrxw1EvoHDfiqKjsMeta } from "/opt/buildhome/repo/app/pages/show/[show].vue?macro=true";
import { default as _91year_93DE_0Qd_PZcIYQKhVcxTy6suP6Yk_eI9UYxLhihVsZrQMeta } from "/opt/buildhome/repo/app/pages/shows/[year].vue?macro=true";
import { default as indexkKqWmR3iAPfCGmxMFgvlrrX4rVa5HVzhTUWsK1ja6LYMeta } from "/opt/buildhome/repo/app/pages/shows/index.vue?macro=true";
export default [
  {
    name: "champs-year-year",
    path: "/champs/year/:year()",
    component: () => import("/opt/buildhome/repo/app/pages/champs/year/[year].vue")
  },
  {
    name: "shows-watch-year__episode",
    path: "/shows/watch/:year()__:episode()",
    component: () => import("/opt/buildhome/repo/app/pages/shows/watch/[year]__[episode].vue")
  },
  {
    name: "champ-contestant",
    path: "/champ/:contestant()",
    meta: _91contestant_93jLnCpFi2zHZGiElxxfbDqJEpJC3x2u8ZY6olxRgrv7QMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/champ/[contestant].vue")
  },
  {
    name: "show-show",
    path: "/show/:show()",
    meta: _91show_93OJzgf_HFFv4744gROOKEgqWkeEIwrxw1EvoHDfiqKjsMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/show/[show].vue")
  },
  {
    name: "shows-year",
    path: "/shows/:year()",
    meta: _91year_93DE_0Qd_PZcIYQKhVcxTy6suP6Yk_eI9UYxLhihVsZrQMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/shows/[year].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/opt/buildhome/repo/app/pages/404.vue")
  },
  {
    name: "link-crawl",
    path: "/link-crawl",
    component: () => import("/opt/buildhome/repo/app/pages/link-crawl.vue")
  },
  {
    name: "quizculator",
    path: "/quizculator",
    component: () => import("/opt/buildhome/repo/app/pages/quizculator.vue")
  },
  {
    name: "shows",
    path: "/shows",
    meta: indexkKqWmR3iAPfCGmxMFgvlrrX4rVa5HVzhTUWsK1ja6LYMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/shows/index.vue")
  },
  {
    name: "streaks",
    path: "/streaks",
    component: () => import("/opt/buildhome/repo/app/pages/streaks.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/opt/buildhome/repo/app/pages/test.vue")
  },
  {
    name: "whut",
    path: "/whut",
    component: () => import("/opt/buildhome/repo/app/pages/whut.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/app/pages/index.vue")
  }
]